import { useState } from "react";

import { editObjectData } from "@aclymatepackages/array-immutability-helpers";

import TransactionDetailsBlock from "./TransactionDetailsBlock";

import { useUpdateTransactions } from "../../../helpers/components/emissions";
import useEmissionsContext from "../../../helpers/contexts/emissions";

const EditRowTransactions = ({
  transaction,
  setIsSlideOpen,
  setEmissions,
  ...otherProps
}) => {
  const { id, tonsCo2e: originalTonsCo2e } = transaction;

  const { vendors } = useEmissionsContext();
  const updateTransactions = useUpdateTransactions();

  const [editableTransaction, setEditableTransaction] = useState(transaction);

  const editTransaction = (field) => (value) =>
    editObjectData(setEditableTransaction, field, value);

  const onRejectTransaction = async () => {
    setIsSlideOpen(null);

    await updateTransactions([{ id, archived: true }]);

    if (setEmissions) {
      setEmissions((prevEmissions) =>
        prevEmissions.map((emission) =>
          emission.id === id ? { ...emission, archived: true } : emission,
        ),
      );
    }
  };

  const findUpdateTonsCo2e = (updateTonsCo2e) =>
    !isNaN(Number(updateTonsCo2e)) ? updateTonsCo2e : originalTonsCo2e;

  const onSaveTransaction = async (updateObj) => {
    const {
      vendorId = null,
      vendorName = null,
      subcategory,
      naicsCode: updateNaicsCode,
      naicsTitle: updateNaicsTitle,
      tonsCo2ePerDollar,
      scopeThreeCategory: updateScopeThreeCategory,
      tonsCo2e: updateTonsCo2e,
      amount,
      emissionData,
      ...otherUpdates
    } = updateObj;
    const vendor = vendors.find((vendor) => vendor?.id === vendorId);

    const { tonsCo2ePerDollar: vendorTonsCo2ePerDollar } = vendor || {};

    if (setEmissions) {
      setEmissions((prevEmissions = []) =>
        prevEmissions.map((emission = {}) =>
          emission.id === id
            ? {
                ...emission,
                ...otherUpdates,
                vendorId,
                vendorName,
                subcategory,
                amount,
                tonsCo2e: findUpdateTonsCo2e(updateTonsCo2e),
                emissionData
              }
            : emission,
        ),
      );
    }

    const findTonsCo2e = () => {
      if (vendorTonsCo2ePerDollar) {
        return vendorTonsCo2ePerDollar * amount;
      }

      return findUpdateTonsCo2e(updateTonsCo2e);
    };

    await updateTransactions([
      {
        id,
        ...otherUpdates,
        vendorId,
        vendorName,
        subcategory,
        amount,
        tonsCo2e: findTonsCo2e(),
        emissionData
      }
    ]);
    return setIsSlideOpen(null);
  };

  return (
    <TransactionDetailsBlock
      showDocumentationTab
      originalTransaction={transaction}
      transaction={editableTransaction}
      editTransaction={editTransaction}
      setIsSlideOpen={setIsSlideOpen}
      onRejectTransaction={onRejectTransaction}
      saveTransaction={onSaveTransaction}
      setEmissions={setEmissions}
      {...otherProps}
    />
  );
};

export default EditRowTransactions;
